(ns rothko.dom.input
  (:require [goog.object :refer [forEach]]))

(defn event->key
  [event]
  (assert (= "keydown" (.-type event)))
  (let [key {:key (.-key event)
         :meta (.-metaKey event)
         :ctrl (.-ctrlKey event)
         :shift (.-shiftKey event)
         :alt (.-altKey event)}]
    (prn "key" key)
    key))

(defn event->value
  [event]
  (.. event -target -value))

(defn click->dom
  [event]
  (first (.. event composedPath)))

(extend-type js/DOMStringMap
  IEncodeClojure
  (-js->clj [x options]
    (let [result (volatile! {})]
      (forEach x (fn [val key obj]
                   (when-not (re-matches #"^cljs.*" key)
                     (vswap! result assoc (keyword key) val))))
      @result)))

(defn target->data-attr
  [event data-attribute]
  (get (js->clj (.. event -currentTarget -dataset)) data-attribute))

(defn select
  [event]
  ;; Using the timeout for Safari as of (MacOS 12.1.1 (14607.2.6.1.1)).
  ;; Event needs to be persisted or React will add it back to the
  ;; event pool before the next animation frame
  (.persist event)
  (js/setTimeout #(.. event -target select) 0))

(defn deselect
  [event]
  (.. event -target blur))
